import React from "react";
import styles from "./index.module.scss";

const SubTitle = ({ children }) => {
  return <div className={styles.customSubTitle}>{children}</div>;
};

export default SubTitle;
